import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import BuyWater from "./pages/buy-water/BuyWater";
import Transactions from "./pages/Transactions";
import ReportLeakage from "./pages/ReportLeakage";
import { Login } from "./pages/Login";
import InvalidRoute from "./helper/InvalidRoute";
import { RequireAuth } from "./helper/RequireAuth";
import About from "./pages/About";
import Contact from "./pages/Contact";
import SignUp from "./pages/SignUp";
import { routes } from "./helper/misc";
import Pay from "./pages/buy-water/Pay";
import Receipt from "./pages/buy-water/Receipt";
import ForgotPassword from "./components/ForgotPasswordComponents/ForgotPassword";
import ForgotPasswordSuccess from "./components/ForgotPasswordComponents/ForgotPasswordSuccess";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import DataDeletionRequest from "./pages/DataDeletionRequest";
import ManageMeters from "./pages/ManageMeters";
import { useAuth } from "./helper/auth";

const AppRoutes = () => {
  const { pathname } = useLocation();
  const auth = useAuth();
  const user = auth?.user;
  useEffect(() => {
    window.scroll(0, 0);
  }, [pathname]);

  return (
    <Routes>
      <Route path={routes.data_deletion} element={<DataDeletionRequest />} />
      <Route path={routes.privacy_policy} element={<PrivacyPolicy />} />
      <Route path={routes.forgot_password} element={<ForgotPassword />} />
      <Route
        path={routes.forgot_password_success}
        element={<ForgotPasswordSuccess />}
      />
      <Route path={routes.home} element={<Home />} />
      <Route
        path={routes.manage_meters}
        element={
          <RequireAuth>
            <ManageMeters />
          </RequireAuth>
        }
      />
      <Route
        path={routes.buy_water}
        element={
          <RequireAuth requiresMeters>
            <BuyWater />
          </RequireAuth>
        }
      />
      <Route
        path={routes.pay}
        element={
          <RequireAuth requiresMeters>
            <Pay />
          </RequireAuth>
        }
      />
      <Route
        path={routes.receipt}
        element={
          <RequireAuth>
            <Receipt />
          </RequireAuth>
        }
      />
      <Route
        path={routes.transactions}
        element={
          <RequireAuth>
            <Transactions />
          </RequireAuth>
        }
      />
      <Route
        path={routes.report_leakage}
        element={
          user ? (
            <RequireAuth>
              <ReportLeakage authenticated />
            </RequireAuth>
          ) : (
            <ReportLeakage />
          )
        }
      />
      <Route path={routes.login} element={<Login />} />
      <Route path={routes.about} element={<About />} />
      <Route path={routes.contact} element={<Contact />} />
      <Route path={routes.signup} element={<SignUp />} />
      <Route path="*" element={<InvalidRoute />} />
    </Routes>
  );
};

export default AppRoutes;
